/*
 * @Description: 
 * @Author: jinxiaojian
 * @Email: jinxiaojian@youxin.com
 * @Date: 2019-08-20 16:32:15
 * @LastEditTime: 2019-08-25 17:11:37
 * @LastEditors: 靳肖健
 */


import Vue from 'vue'
import VueRouter from 'vue-router'
import home from "./home.vue"

Vue.use(VueRouter)

const routes = [{
  path: '/',
  name: 'home',
  component: home
},
]

export default new VueRouter({
  routes: routes
})